import React, { useEffect, useState } from "react";
// import useGenerateOrder from "../../hooks/useGenerateOrder";
import Select from "react-select";
import {
  PriceResponse,
  useJewelleryContext,
} from "context/JwelleryPriceContext";
import { useOrderContext } from "../../hooks/useGenerateOrder";

const ConfirmOrder = () => {
  const {
    paymentMethod,
    paymentStatus,
    jewellery,
    selectedMetal,
    selectedKarat,
    selectedPaymentType,
    setSelectedPaymentType,
    selectedPaymentStatus,
    setSelectedPaymentStatus,
    generateOrderValue,
    note,
    setNote,
    selectedSize,
  } = useOrderContext();
  const [orderPrice, setOrderPrice] = useState({
    subTotal: 0,
    taxAmount: 0,
    discountPrice: 0,
    totalPrice: 0,
  });

  const [price, setPrice] = useState<PriceResponse[]>([]); // State for price
  const { getDiamondPrices, handleJewelleryPrice } = useJewelleryContext();

  // useEffect(() => {
  //   if (jewellery) {
  //     const mainDiamond = {
  //       id: "main-stone",
  //       carat: 1,
  //       color: "DEF",
  //       clarity: "VVS",
  //       shape: jewellery?.shape, // Using product shape
  //       pieces: 1,
  //     };

  //     const diamondsWithMain: any = [
  //       mainDiamond,
  //       ...(jewellery?.diamonds || []),
  //     ];
  //     if (diamondsWithMain) {
  //       (async () => {
  //         const response: any = await getDiamondPrices(diamondsWithMain);
  //         setPrice(response);
  //       })();
  //     }
  //   }
  // }, [jewellery]);

  // useEffect(() => {
  //   const {
  //     subTotal,
  //     // diamondPrices,
  //     taxAmount,
  //     discountPrice,
  //     totalPrice,
  //   } = handleOrderJewelleryPrice(
  //     jewellery,
  //     selectedMetal,
  //     selectedKarat,
  //     // price,
  //     "combined",
  //     Number(process.env.REACT_APP_JEWELLERY_MARGIN_PRICE || 0),
  //     Number(process.env.REACT_APP_JEWELLERY_TAX_PRICE || 0)
  //   );

  //   setOrderPrice({
  //     subTotal,
  //     taxAmount,
  //     discountPrice,
  //     totalPrice, // apply discount
  //   });
  // }, [jewellery, price, selectedMetal, selectedKarat]);

  const totalJewelleryPrice: any = handleJewelleryPrice(
    jewellery,
    selectedMetal,
    selectedKarat,
    // price,
    selectedSize,
    "combined"
  );

  console.log(totalJewelleryPrice);

  return (
    <div className="card p-5">
      <p className="pb-4 pb-2 text-[16px] font-semibold">Confirm Order</p>
      <hr className="" />
        <div className="pt-5">
          <label
            htmlFor={`sectionTitle`}
            className="inline-block mb-2 text-base font-medium"
          >
            Payment Method
          </label>
          <Select
            className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
            options={paymentMethod}
            value={paymentMethod.find((opt) => opt.value === selectedPaymentType)}
            onChange={(option) => {
              setSelectedPaymentType(option?.value || "");
              generateOrderValue.setFieldValue("paymentMethod", option?.value);
            }}
          />
          {generateOrderValue.touched.paymentMethod &&
            generateOrderValue.errors.paymentMethod && (
              <p className="text-sm text-red-500 mt-1">
                {generateOrderValue.errors.paymentMethod}
              </p>
            )}
        </div>
      <div className="pt-5">
        <label
          htmlFor={`sectionTitle`}
          className="inline-block mb-2 text-base font-medium"
        >
          Payment Status
        </label>
        <Select
          className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
          options={paymentStatus}
          value={paymentStatus.find(
            (opt) => opt.value === selectedPaymentStatus
          )}
          onChange={(option) => {
            setSelectedPaymentStatus(option?.value || "");
            generateOrderValue.setFieldValue("paymentStatus", option?.value);
          }}
        />
        {generateOrderValue.touched.paymentStatus &&
          generateOrderValue.errors.paymentStatus && (
            <p className="text-sm text-red-500 mt-1">
              {generateOrderValue.errors.paymentStatus}
            </p>
          )}
      </div>
      <div className="pt-5">
        <label htmlFor={`sectionTitle`} className="mb-2 text-base font-medium">
          Note
        </label>
        <div className="mt-2">
          <textarea
            placeholder="Add Note.."
            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
            id="textArea"
            rows={3}
            value={note}
            onChange={(e) => {
              const value = e.target.value;
              setNote(value);
              generateOrderValue.setFieldValue("note", value);
            }}
          ></textarea>
        </div>
        {generateOrderValue.touched.note && generateOrderValue.errors.note && (
          <p className="text-sm text-red-500 mt-1">
            {generateOrderValue.errors.note}
          </p>
        )}
      </div>
      <div className="space-y-3 pt-5 flex items-end flex-col">
        <div className="flex border-b w-[50%] justify-between border-slate-200 dark:border-zink-500 px-3.5 py-2.5">
          <span className="text-slate-500 dark:text-zink-200">Sub Total</span>
          <span className="font-medium text-slate-700 dark:text-zink-100">
            {totalJewelleryPrice?.subTotal
              ? `$${Math.round(totalJewelleryPrice?.subTotal)}`
              : "$00"}
          </span>
        </div>
        <div className="flex border-b w-[50%] justify-between border-slate-200 dark:border-zink-500 px-3.5 py-2.5">
          <span className="text-slate-500 dark:text-zink-200">
            Estimated Tax (18%)
          </span>
          <span className="font-medium text-slate-700 dark:text-zink-100">
            {totalJewelleryPrice?.taxAmount
              ? `$${Math.round(totalJewelleryPrice?.taxAmount)}`
              : "$00"}
          </span>
        </div>

        <div className="flex border-b w-[50%] justify-between border-slate-200 dark:border-zink-500 px-3.5 py-2.5">
          <span className="text-slate-500 dark:text-zink-200">
            Item Discounts
          </span>
          <span className="font-medium text-red-500 dark:text-red-400">
            {totalJewelleryPrice?.discountPrice
              ? `-$${Math.round(totalJewelleryPrice?.discountPrice)}`
              : "-$00"}
          </span>
        </div>

        <div className="flex border-b w-[50%] justify-between border-slate-200 dark:border-zink-500 px-3.5 py-2.5">
          <span className="text-slate-500 dark:text-zink-200">
            Shipping Charge
          </span>
          <span className="font-medium text-slate-700 dark:text-zink-100">
            $00
          </span>
        </div>

        <div className="flex border-b w-[50%] justify-between border-slate-200 dark:border-zink-500 px-3.5 py-2.5">
          <span className="text-slate-500 dark:text-zink-200">
            Total Amount
          </span>
          <span className="font-bold text-lg text-slate-900 dark:text-zink-100">
            {totalJewelleryPrice.totalPrice
              ? `$${Math.round(totalJewelleryPrice.totalPrice)}`
              : "$00"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ConfirmOrder;
